import React from 'react';
import { IconHeartWhite, IconHeartFull } from '@commons/images';
import * as S from './MovieCard.style';
const ImageNotFound = () => (React.createElement(S.ImageNotFound, null,
    React.createElement(S.ImageNotFoundIcon, null, ":("),
    React.createElement(S.ImageNotFoundText, null, "Image not found")));
export const MovieCard = ({ active, imgUrl, hoverOff, title, year, onClick }) => {
    const activeImage = active ? IconHeartFull : IconHeartWhite;
    return (React.createElement(S.MovieCard, { hoverOff: hoverOff },
        imgUrl !== 'N/A' && React.createElement(S.Img, { loading: "lazy", src: imgUrl, alt: title, width: "170", height: "230" }),
        imgUrl === 'N/A' && React.createElement(ImageNotFound, null),
        React.createElement(S.DetailLayer, { asFav: active },
            React.createElement(S.IconWrapper, null,
                React.createElement("img", { loading: "lazy", src: activeImage, width: "24", height: "24", "data-testid": "set-as-fav", onClick: onClick })),
            React.createElement(S.DetailLayerWrapper, null,
                React.createElement(S.Title, null, title),
                React.createElement(S.Year, null, year)))));
};
//# sourceMappingURL=MovieCard.js.map